/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageContainerSortimentPageResponse } from '../../models/page-container-sortiment-page-response';

export interface GetContainerSortiment$Params {

/**
 * Filter on brand
 */
  brand?: string;

/**
 * Filter on name
 */
  name?: string;

/**
 * Filter on amount
 */
  amount?: string;

/**
 * Filter on unit
 */
  unit?: 'LITERS' | 'KILOGRAMS';

/**
 * Filter on mainType of container
 */
  mainType?: 'STANDALONE' | 'COLLECTION';

/**
 * Filter on subType of container
 */
  subType?: string;

/**
 * Filter on ean
 */
  ean?: string;

/**
 * Filter on fixSupplierName
 */
  fixSupplierName?: string;

/**
 * Filter on expirationOfSupplierContract
 */
  expirationOfSupplierContract?: string;

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function getContainerSortiment(http: HttpClient, rootUrl: string, params?: GetContainerSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<PageContainerSortimentPageResponse>> {
  const rb = new RequestBuilder(rootUrl, getContainerSortiment.PATH, 'get');
  if (params) {
    rb.query('brand', params.brand, {});
    rb.query('name', params.name, {});
    rb.query('amount', params.amount, {});
    rb.query('unit', params.unit, {});
    rb.query('mainType', params.mainType, {});
    rb.query('subType', params.subType, {});
    rb.query('ean', params.ean, {});
    rb.query('fixSupplierName', params.fixSupplierName, {});
    rb.query('expirationOfSupplierContract', params.expirationOfSupplierContract, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageContainerSortimentPageResponse>;
    })
  );
}

getContainerSortiment.PATH = '/sortiments/containers';
